// extracted by mini-css-extract-plugin
export var $animation_name = "PaymentBanner-module--$animation_name--c9143";
export var paymentBanner = "PaymentBanner-module--paymentBanner--2f585";
export var paymentBanner__image = "PaymentBanner-module--paymentBanner__image--b78c9";